//Plugin Ultimate Member custom scripts

jQuery(document).ready(function($) {
    
    // Create the loader toast HTML (Bootstrap 5 style)
    function createLoader() {
        if ($('#um-ajax-loader').length === 0) {
            const loaderHTML = `
                <div class="toast-container position-fixed bottom-0 end-0 p-3" >
                    <div id="um-ajax-loader" class="toast align-items-center bg-primary text-white border-0" role="alert" aria-live="assertive" aria-atomic="true" style="display: none;">
                        <div class="d-flex">
                            <div class="toast-body d-flex align-items-center">
                                <div class="spinner-border spinner-border-sm text-white me-2" role="status" aria-hidden="true"></div>
                                <span>Chargement en cours...</span>
                            </div>
                        </div>
                    </div>
                </div>
            `;
            $('body').append(loaderHTML);
        }
    }
    
    // Show the loader toast
    function showLoader() {
        createLoader();
        $('#um-ajax-loader').removeClass('hide').addClass('show').fadeIn(300);
    }
    
    // Hide the loader toast
    function hideLoader() {
        $('#um-ajax-loader').removeClass('show').addClass('hide').fadeOut(300);
    }
    
    // Counter to handle multiple simultaneous requests
    let activeRequests = 0;
    
    // Intercept Ultimate Member AJAX calls
    $(document).ajaxSend(function(event, xhr, settings) {
        // Check if it's an Ultimate Member request
        if (settings.url && (
            settings.url.indexOf('um_') !== -1 || 
            settings.url.indexOf('ultimatemember') !== -1 ||
            (settings.data && typeof settings.data === 'string' && settings.data.indexOf('um_') !== -1) ||
            (settings.data && settings.data.action && settings.data.action.indexOf('um_') !== -1)
        )) {
            activeRequests++;
            if (activeRequests === 1) {
                showLoader();
            }
        }
    });
    
    // Hide the loader when the request completes (success)
    $(document).ajaxComplete(function(event, xhr, settings) {
        if (settings.url && (
            settings.url.indexOf('um_') !== -1 || 
            settings.url.indexOf('ultimatemember') !== -1 ||
            (settings.data && typeof settings.data === 'string' && settings.data.indexOf('um_') !== -1) ||
            (settings.data && settings.data.action && settings.data.action.indexOf('um_') !== -1)
        )) {
            activeRequests--;
            if (activeRequests <= 0) {
                activeRequests = 0;
                hideLoader();
            }
        }
    });
    
    // Hide the loader in case of error
    $(document).ajaxError(function(event, xhr, settings) {
        if (settings.url && (
            settings.url.indexOf('um_') !== -1 || 
            settings.url.indexOf('ultimatemember') !== -1 ||
            (settings.data && typeof settings.data === 'string' && settings.data.indexOf('um_') !== -1) ||
            (settings.data && settings.data.action && settings.data.action.indexOf('um_') !== -1)
        )) {
            activeRequests--;
            if (activeRequests <= 0) {
                activeRequests = 0;
                hideLoader();
            }
        }
    });
    
    // Listen specifically to Ultimate Member events if available
    if (typeof UM !== 'undefined') {
        // Hook into Ultimate Member events if the plugin exposes events
        $(document).on('um_before_ajax', function() {
            activeRequests++;
            if (activeRequests === 1) {
                showLoader();
            }
        });
        
        $(document).on('um_after_ajax', function() {
            activeRequests--;
            if (activeRequests <= 0) {
                activeRequests = 0;
                hideLoader();
            }
        });
    }
    
    // Also intercept Ultimate Member form submissions
    $(document).on('submit', '.um-form', function() {
        showLoader();
    });
    
    // Observe DOM changes to detect dynamic UM forms
    const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.type === 'childList') {
                // Check if Ultimate Member elements have been added
                $(mutation.addedNodes).find('.um-form').each(function() {
                    $(this).on('submit', function() {
                        showLoader();
                    });
                });
            }
        });
    });
    
    // Start observation
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
    
    // Utility function to force display the loader (usable from other scripts)
    window.umShowLoader = showLoader;
    window.umHideLoader = hideLoader;
    
    console.log('Ultimate Member AJAX Loader (Bootstrap Toast) initialized');
});


